import { CardContent, Typography, Box } from '@mui/material';
import { EmailContentSection } from './EmailContentSection';
import { Visibility, Edit, Save } from '@mui/icons-material';
import { PreviewCard as PreviewCardComponent, ActionButtons, ActionButton, SubjectLine, EmailBody } from './StyledComponents';
// import WheelerWatingMAIQ from '../../../../../../components/WheelerWatingMAIQ'; // Removed - using GenerationProgressPopupMAIQ instead
import { GenerationProgressPopupMAIQ } from 'app/components/GenerationProgressPopupMAIQ';

export const PreviewCard = ({
  emailContent,
  isGenerating,
  isGeneratingEmail,
  generatedEmail,
  onPreview,
  handleEditClick,
  handleSaveTemplateClick,
  streamingData = null,
  streamingText = '',
  currentSection = null,
  showActionButtons = true,
}: {
  emailContent: any;
  isGenerating: boolean;
  isGeneratingEmail: boolean;
  generatedEmail: any;
  onPreview: () => void;
  handleEditClick: () => void;
  handleSaveTemplateClick: () => void;
  streamingData?: any;
  streamingText?: string;
  currentSection?: {index: number; type: string} | null | undefined;
  showActionButtons?: boolean;
}) => {
  return (
    <>
      <PreviewCardComponent>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, position: 'relative' }}>
          {/* Generating overlay */}
          {isGenerating && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                borderRadius: 1,
              }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  component="span"
                  sx={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'inline-block',
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{ mt: 1, color: 'text.secondary' }}
                >
                  Generating email content...
                </Typography>
              </Box>
            </Box>
          )}

          <SubjectLine>
            <Typography>
              <strong>Subject:</strong> {emailContent.subject}
            </Typography>
          </SubjectLine>

          <EmailBody>
            {isGeneratingEmail ? (
              <Box sx={{ 
                textAlign: 'center', 
                py: 6,
                px: 3,
                backgroundColor: 'grey.50',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.200'
              }}>
                <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1rem' }}>
                  Generating email content...
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
                  Please wait while we create your personalized email
                </Typography>
              </Box>
            ) : (
              emailContent.sections.map(el => (
                <EmailContentSection
                  key={el.id}
                  variant={el.variant}
                  emailSection={el}
                />
              ))
            )}
          </EmailBody>

          {/* Show action buttons when we have substantial email content */}
          {showActionButtons && (
            <>
              <ActionButtons>
                <ActionButton
                  variant="outlined"
                  startIcon={<Visibility />}
                  onClick={onPreview}
                  disabled={isGenerating || !generatedEmail}
                  sx={{
                    opacity: (isGenerating || !generatedEmail) ? 0.6 : 1,
                    pointerEvents: (isGenerating || !generatedEmail) ? 'none' : 'auto',
                  }}
                >
                  {generatedEmail ? 'View Generated Email' : 'Preview'}
                </ActionButton>
                <ActionButton
                  variant="outlined"
                  startIcon={<Edit />}
                  onClick={handleEditClick}
                  disabled={isGenerating || !generatedEmail}
                  sx={{
                    opacity: (isGenerating || !generatedEmail) ? 0.6 : 1,
                    pointerEvents: (isGenerating || !generatedEmail) ? 'none' : 'auto',
                  }}
                >
                  Edit
                </ActionButton>
                <ActionButton
                  variant="contained"
                  startIcon={<Save />}
                  onClick={handleSaveTemplateClick}
                  color="primary"
                  disabled={isGenerating || !generatedEmail}
                  sx={{
                    opacity: (isGenerating || !generatedEmail) ? 0.6 : 1,
                    pointerEvents: (isGenerating || !generatedEmail) ? 'none' : 'auto',
                  }}
                >
                  Save as template
                </ActionButton>
              </ActionButtons>

              {/* Show message when buttons are disabled */}
              {!generatedEmail && !isGenerating && (
                <Box sx={{ 
                  textAlign: 'center', 
                  py: 2, 
                  color: 'text.secondary',
                  fontStyle: 'italic',
                  fontSize: '14px'
                }}>
                  <Typography variant="body2">
                    Complete the chat flow to generate email and enable these actions
                  </Typography>
                </Box>
              )}
            </>
          )}

          {/* Show generating message when no content yet */}
          {/* {isGenerating && !emailContent.openingMessage && !emailContent.valueHighlight && !emailContent.specialOffer && !emailContent.secondaryOffer && step < 6 && (
            <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
              <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                Email content is being generated. Please wait...
              </Typography>
            </Box>
          )} */}
        </CardContent>
      </PreviewCardComponent>

      {/* NEW: Generation Progress Popup - Shows detailed progress in popup */}
      {isGeneratingEmail && (
        <GenerationProgressPopupMAIQ
          open={isGeneratingEmail}
          isGenerating={isGeneratingEmail}
          streamingData={streamingData}
          streamingText={streamingText}
          currentSection={currentSection || undefined}
          sections={streamingData?.message?.sections || []}
          isFinal={streamingData?.message?.isFinal || false}
          showProgress={true}
          message="Generating Email..."
        />
      )}
    </>
  );
}